import React from "react";
import BaseLayout from "./baseLayout";
import ReactDOM from "react-dom";

interface IWithLayout {
  cmp: React.ReactNode;
  id?: string;
  params?: {
    AdTopBanner?: boolean;
    nav?: "" | "SlimNav" | "DefaultFixedNav";
    footer?: "" | "Footer";
    needRTBH?: boolean;
    webPageNav?: boolean;
    singlePageNav?: boolean;
  };
}
const withLayout = ({ cmp, id = "container", params }: IWithLayout) => {
  const $container = document.getElementById(id);
  $container && ReactDOM.render(<BaseLayout params={params || {}}>{cmp}</BaseLayout>, $container);
};

export default withLayout;
